import { useSystemStore } from '../stores/SystemStore';
import type { User } from '../types/local';

export const useUser = (): User => {
	const user = useSystemStore(state => state.user);
	if (!user) {
		throw new Error('User is not defined');
	}

	return user;
};
